import { render, staticRenderFns } from "./Dietary.vue?vue&type=template&id=1bfebfae&scoped=true"
import script from "./Dietary.vue?vue&type=script&lang=js"
export * from "./Dietary.vue?vue&type=script&lang=js"
import style0 from "./Dietary.vue?vue&type=style&index=0&id=1bfebfae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfebfae",
  null
  
)

export default component.exports